import zh from '../../resources/locales/zh-CN.json';
export default {
  ...zh,
  ...JSON.parse(localStorage.getItem('overrides_translations') || '{}')['zh-CN'],
};
